import { useEffect, useState } from "react";

import { bewaarConsent, leesConsent, pasConsentToe, type ConsentKeuze } from "@/lib/consent";
import { Link } from "@tanstack/react-router";

export function Cookiebanner() {
  const [zichtbaar, setZichtbaar] = useState(false);

  useEffect(() => {
    const keuze = leesConsent();
    if (keuze) {
      pasConsentToe(keuze);
    } else {
      setZichtbaar(true);
    }
  }, []);

  useEffect(() => {
    const open = () => setZichtbaar(true);
    window.addEventListener("open-cookie-settings", open);
    return () => window.removeEventListener("open-cookie-settings", open);
  }, []);

  function kies(keuze: ConsentKeuze) {
    bewaarConsent(keuze);
    setZichtbaar(false);
  }

  if (!zichtbaar) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookievoorkeuren"
      className="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-4"
    >
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-3 rounded-lg border border-border bg-card p-4 shadow-lg sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-foreground">
          Met jouw toestemming gebruiken we Google Analytics en Google Ads om websitebezoek en verzonden aanvragen te meten.
          Je kunt ook zonder deze meting aanvragen doen. <Link to="/privacy" className="underline">Privacy en cookies</Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => kies("geweigerd")}
            className="rounded-lg border border-border px-4 py-2 text-sm font-semibold"
          >
            Weigeren
          </button>
          <button
            type="button"
            onClick={() => kies("geaccepteerd")}
            className="rounded-lg bg-accent px-4 py-2 text-sm font-extrabold text-accent-foreground"
          >
            Accepteren
          </button>
        </div>
      </div>
    </div>
  );
}
